import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function BrandingSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Branding"
      description="Workspace logo, header image, share-link accent color. Deferred to Phase 2."
    />
  );
}
